import { accountServiceModule } from '../../../../shared/app/services/account-service/account-service';
import { ablyClientServiceModule } from '../../../../shared/app/services/ably-client-service/ably-client-service';
import { appConfig } from '../../../../shared/app/constants/app-config';
import * as ArrayUtils from '../../../../shared/app/utils/array-utils';

export const attachServiceModule = angular
  .module('Q.services.attach-service', [
    accountServiceModule,
    ablyClientServiceModule,
  ])

  .factory(
    'attachService',
    function ($q, $http, $log, $timeout, accountService, ablyClientService) {
      let channelServices = {};

      const svc = {
        /**
         * Creates a channel for listening to attach events
         * @param challengeId {String} Challenge ID for the socket channel
         * @param $scope {rootScope.Scope?} Optional scope to automatically clean up subscriptions when destroyed
         * @returns {*}
         */
        create(challengeId, $scope) {
          const accountUser = accountService.get().user;

          if (!accountUser) {
            $log.error(
              'Invariant violation: accountUser was unexpectedly undefined',
            );
            return;
          }

          const { channel, channelError } = ablyClientService.connect({
            svc,
            clientKey: 'attach',
            clientId: accountUser.id,
            tokenUrl: `${appConfig.baseApiRoot}attach/ably_token`,
            channelId: `attach:${accountUser.id}:${challengeId}`,
            channelEventPrefix: 'attach',
          });

          if (!channel || channelError) {
            throw new Error(
              'Unable to connect to realtime channel. Please make sure you are not running any content blockers, and reload the page.',
              { cause: channelError },
            );
          }

          // Enter presence so that Attach can make sure the browser is connected.
          // Will also emit `leave` when the browser disconnects.
          channel.presence.enter({ app: 'assess' });

          let subs = [];
          const channelService = {
            channel,
            subscribe(event, handler) {
              const existing = subs.find(
                ([subEvent, subHandler]) =>
                  subEvent === event && subHandler === handler,
              );
              if (existing) {
                return existing[2];
              }
              channel.subscribe(event, handler);
              const unsub = () => channelService.unsubscribe(event, handler);
              subs.push([event, handler, unsub]);
              return unsub;
            },
            unsubscribe(event, handler) {
              channel.unsubscribe(event, handler);
              const idx = subs.findIndex(
                ([event, handler]) => event === event && handler === handler,
              );
              if (idx > -1) {
                subs.splice(idx, 1);
              }
            },
            destroy() {
              subs.forEach((sub) => channelService.unsubscribe(sub[0], sub[1]));
              subs.length = 0;
              ArrayUtils.remove(channelServices[challengeId], channelService);
              if (channelServices[challengeId].length === 0) {
                // nobody listening, shut down this socket
                ablyClientService.destroy(svc);
              }
            },
          };

          if ($scope) {
            $scope.$on('$destroy', () => {
              // clean up any subscribers. Run out-of-digest, and delayed since it's low priority
              $timeout(channelService.destroy, 1000, false);
            });
          }

          if (!channelServices[challengeId]) channelServices[challengeId] = [];
          channelServices[challengeId].push(channelService);

          return channelService;
        },
      };

      return svc;
    },
  );
